export default __webpack_public_path__ + "static/media/SNFM.85de3e05.svg";